export enum ProductSortType {
  PRICE = 'PRICE',
  NAME = 'NAME',
}
